import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCJKH8RhWB_TWao-nrJOfnIuNHx-JNVlSY",
  authDomain: "route-planning-56b52.firebaseapp.com",
  projectId: "route-planning-56b52",
  storageBucket: "route-planning-56b52.firebasestorage.app",
  messagingSenderId: "559056041486",
  appId: "1:559056041486:web:f3f4d1a92853ea1d062e5f",
  measurementId: "G-9PZ4WBZ6Y1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { auth, analytics, db }; 